import { User } from '@/models/user'
import { BaseAPI } from '@/api/base.api'
import { API_URL_SERVICE, BACK_URL_SERVICE } from '@/commons/config'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'

export interface IResetPasswordInput {
  password: string;
  passwordConfirmation: string;
  token: string;
}

export class UserAPI extends BaseAPI<User> {
  constructor() {
    super()
    this.apiUrl = `${API_URL_SERVICE}/api_dash/v1/users`
  }

  public signin(email: string, password: string): AxiosObservable<User> {
    return this.axios.post(`${this.apiUrl}/sessions`, {
      user: { email, password }
    })
  }

  public forgotPassword(email: string): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/passwords/forgot`, { user: { email } })
  }

  public resetPassword(data: IResetPasswordInput): AxiosObservable<any> {
    return this.axios.patch(`${this.apiUrl}/passwords/reset`, data)
  }
}
